'use strict';

var $ = require('jquery');
var analytics = require('../utils/analytics');

var versionSelectCount = 0;
var versionAutoSelected = false;

var classNames = {
	derivativeLevel: 'derivative-level',
	listContainer: 'list-container',
	derivativeLevelContainer: 'derivative-level-container',
	briefSpecification: 'brief-specification',
	linkButton: 'link-button',
	listItem: 'list__item'
};

var modifiers = {
	derivativeLevelContainerDisabled: 'derivative-level-container--disabled',
	selected: 'selected'
};

function autoSelectSingleDerivative(target) {
	if ($(target).length > 0) {
		var numberOfOptions = $(target.lastElementChild).children().length;
		var singleOption = 1;

		if (numberOfOptions === singleOption) {
			var $listItem = $(target.lastElementChild.firstElementChild);
			versionAutoSelected = true;
			$listItem.trigger('click.item');
		}
	}
}

function resetHighlightedDerivative() {
	var $currentSelected = $.findByBem(classNames.derivativeLevel, classNames.listItem, modifiers.selected);
	$currentSelected.removeBemClass(classNames.derivativeLevel, classNames.listItem, modifiers.selected);
}

function toggleSpecificationsAndLinkButtons($specification, $linkButton) {
	var $briefSpecifications = $.findByBem(classNames.derivativeLevel, classNames.briefSpecification, null);
	var $linkButtons = $.findByBem(classNames.derivativeLevel, classNames.linkButton, null);

	$briefSpecifications.hide().filter($specification).show();
	$linkButtons.hide().filter($linkButton).show();

	resetHighlightedDerivative();
}

function trackVersionSelectEvent() {
	versionSelectCount++;
	analytics.trackEvent('Car Specs Model', 'Version Selected ' + versionSelectCount, window.parkersConfig.dataLayer.vehicle.vehicleName);
}

module.exports = {
	init: function ($context) {
		var $listContainer = $.findByBem(classNames.derivativeLevel, classNames.listContainer, null, $context);
		var $listItems = $.findByBem(classNames.derivativeLevel, classNames.listItem, null, $context);

		if ($listContainer.length > 0) {
			$listContainer.on('display', function (event, selectedEngine) {
				$.findByBem(classNames.derivativeLevelContainer).toggleClass(modifiers.derivativeLevelContainerDisabled, selectedEngine === 'placeholder');
				$listContainer.hide().filter(event.currentTarget).show();

				toggleSpecificationsAndLinkButtons();
				autoSelectSingleDerivative(event.currentTarget);
			});

			$listItems.on('click.item', function (event) {
				var selectedDerivative = $(event.currentTarget).val();

				if (!versionAutoSelected) {
					trackVersionSelectEvent();
				}
				else {
					versionAutoSelected = false;
				}

				var $specification = $('[data-derivative-details-id="' + selectedDerivative + '"]');
				var $linkButton = $('[data-derivative-link-id="' + selectedDerivative + '"]');

				toggleSpecificationsAndLinkButtons($specification, $linkButton);

				$(event.currentTarget).addBemClass(classNames.derivativeLevel, classNames.listItem, modifiers.selected);

				// On hidden elements data equalizer has no effect. Therefor after rendering we need to re-init equalizer
				$(document).foundation().init('equalizer');
			});
		}
	}
};